import { render } from "./AboutSpl.vue?vue&type=template&id=2d6e4f44&scoped=true"
import script from "./AboutSpl.vue?vue&type=script&lang=js"
export * from "./AboutSpl.vue?vue&type=script&lang=js"

import "./AboutSpl.vue?vue&type=style&index=0&id=2d6e4f44&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6e4f44"]])

export default __exports__